import PassportKioskHeaderControl from './PassportKioskHeaderControl';
import { usePassportCheckinEnabled } from '../hooks/usePassportCheckinEnabled';

export default function PassportHeaderToolbar() {
  const enabled = usePassportCheckinEnabled();
  if (!enabled) return null;
  return <PassportKioskHeaderControl />;
}
